
import linq from "linq";
import { Vue, Component, Prop } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
import javaUploadFile from "./javaUploadFile.vue";
import dicSelect from "./dicSelect.vue";
import textEditor from "./text-editor.vue";
import { FilterHelper } from "@newview/tools";
import  EZUIKit from 'ezuikit-js'; 
@Component({
  name: "dynamicForm",
  components: {
    javaUploadFile,
    dicSelect,
    textEditor
  },
})
export default class DynamicForm extends BaseVue {
  @Prop({ default: () => ({}) }) formDynamic!: any; //表单项绑定对象 { items: [Object] }
  @Prop({ default: false })  disabled!: Boolean; //表单是否禁用
  @Prop({ default: () => false }) onlyView!: Boolean; //表单是否只显示不编辑，默认为编辑状态
  data=""
  @Prop({ default: "Insert text here ...." }) placeholder!: any; //token
  //#region =================================Object中内容如下=========================================
  //   Id: 0
  //   category: "基本信息", // 分组信息
  //   code: "interest", // 字段唯一标识
  //   name: "Hobby",    // 显示名称
  //   value: [] | ''    // 存储的值，除了type = checkbox为array类型外，其他为string类型，
  //   orderNo: 1,       // 排序号
  //   formItem: {
  //     type: "checkbox" | "input" | "select" | "datePicker" | "radio",   // FormItem类型
  //     inputType: "textarea",
  //     children: [ // 当类型为"checkbox" | "select" | "radio"是需要配置
  //       { value: "Eat", text: "Eat" },
  //       { value: "Sleep", text: "Sleep" },
  //       { value: "Run", text: "Run" },
  //       { value: "Movie", text: "Movie" }
  //     ],
  //     slot: {
  //       btnFun: "",
  //       btntext: ""
  //     },
  //     max: "",
  //     min: "",
  //     step: "",
  //     pickertype: "",
  //     options: "",
  //     transfer: "",
  //     format: "",
  //     size: ""
  //   },
  //   validate: [ // 验证规则，和iview里的form验证规则配置一样
  //     {
  //       required: true,
  //       type: "array",
  //       min: 1,
  //       message: "Choose at least one hobby",
  //       trigger: "change"
  //     },
  //     {
  //       type: "array",
  //       max: 2,
  //       message: "Choose two hobbies at best",
  //       trigger: "change"
  //     }
  //   ]
  //#endregion
  javaEdit(data,res) {
    data.value = res;
  }
  javaEditNew(data,res){
    data["textToken"]=res;
  }
    getSelectText(value,list){
    return FilterHelper.sysDicFilter(value,list)
  }

  validate(callback) {  
    let _this = this;
     console.log(_this.formDynamic.items);
    (this.$refs["form1"] as any).validate((valid) => {
     if(valid){ 
            callback(valid, _this.formDynamic.items);
     } 
    });
  }

  reset() {
    (this.$refs["form1"] as any).resetFields();
  }
  mounted() {
    const formItems = linq.from(this.formDynamic.items);
    this.formDynamic.items = formItems
      .orderBy((item) => (item as any).orderNo)
      .toArray(); 
      this.$nextTick(()=>{ 
        let vde:any=this.Baselinq.from(this.formDynamic.items).where((f:any)=>f.name=='播放地址').firstOrDefault();  
        if(vde&&vde.token!=undefined){
            new EZUIKit.EZUIKitPlayer({
                  id:'NewVedio',
                  url:vde.value,
                  autoplay: true,
                  accessToken: vde.token,
                  splitBasis:1, //设置窗口切割参数
            });   
        } 
     });
  }
  successToen(item, res) {
    item.value = res;
    console.log(res);
  }
  loadUpToken(item){
    item.value = item.value?item.value:this.NewGuid()
     return item.value
  }
}
